// extracted by mini-css-extract-plugin
export default {"flag":"CardFlag_flag__29H4U","sold-out":"CardFlag_sold-out__19LcF"};